import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './public/login/login.component';
import { ErrorComponent } from './public/error/error.component';
import { ErrorNotFoundComponent } from './public/error-not-found/error-not-found.component';
import { HomeComponent } from './public/home/home.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full', title: 'Login - SaleDesk ERP' },
  { path: 'login', component: LoginComponent, title: 'Login - SaleDesk ERP'  },
  { path: 'home', component: HomeComponent, title: 'Home - SaleDesk ERP'  },
  { path: 'error', component: ErrorComponent, title: 'Error - SaleDesk ERP'  },
  {
    path : 'accounts',
    loadChildren: () => import("./accounts/accounts.module").then(module => module.AccountsModule),
    title: 'Accounts - SaleDesk ERP'
  },
  {
    path : 'ecommerce',
    loadChildren: () => import("./ecommerce/ecommerce.module").then(module => module.EcommerceModule),
    title: 'Ecommerce - SaleDesk ERP'    
  },
  {
    path : 'erp',
    loadChildren: () => import("./erp/erp.module").then(module => module.ErpModule)
  },
  {
    path : 'hrms',
    loadChildren: () => import("./hrms/hrms.module").then(module => module.HrmsModule),
    title: 'HRMS - SaleDesk ERP'
  },
  {
    path : 'service',
    loadChildren: () => import("./service-module/service.module").then(module => module.ServiceModule),
    title: 'Service - SaleDesk ERP'
  },
  {
    path : 'admin',
    loadChildren: () => import("./admin/admin.module").then(module => module.AdminModule),
    title: 'Admin - SaleDesk ERP'
  },
  {
    path : 'sales',
    loadChildren: () => import("./sales/sales.module").then(module => module.SalesModule),
    title: 'Sales & Distribution - SaleDesk ERP'
  },
  {
    path : 'analytics',
    loadChildren: () => import("./analytics/analytics.module").then(module => module.AnalyticsModule),
    title: 'Analytics - SaleDesk ERP'
  },
  {
    path : 'business',
    loadChildren: () => import("./business/business.module").then(module => module.BusinessModule),
    title: 'Business - SaleDesk ERP'
  },
  { path: '**', component: ErrorNotFoundComponent, title: 'Page Not Found - SaleDesk ERP'  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

